import { IN_TO_M } from '../constants';
import message from './message';

export function updateUprightPosition(claraApi, appState) {
  const { configuration } = appState;
  const uprightPosition = configuration.uprightPosition.value;
  const parentId = configuration.uprights.modelId;
  claraApi.scene.set(
    {
      from: { id: parentId },
      name: 'uprightPosition',
      plug: 'Transform',
      property: 'translation',
    },
    {
      x: 0,
      y: uprightPosition * IN_TO_M,
      z: 0,
    }
  );
  claraApi.player.frameScene();
}

export function updateFeetPosition(claraApi, appState) {
  const { configuration, models } = appState;
  const parentId = configuration.feetAndCasters.modelId;
  const baseWidth = configuration.width.value;
  const base = models[configuration.base.modelId].value.replace(/\d/g, '');
  const legWidth = 5.33;
  const distanceOffset = legWidth / 2 + 2;
  let feetDistance = 0;
  switch (base) {
    case 'AF':
    case 'PB':
      feetDistance = Math.min(72, baseWidth) - distanceOffset;
      break;
    default:
      feetDistance = baseWidth - distanceOffset;
  }

  claraApi.scene.set(
    {
      from: { id: parentId },
      name: 'rightFoot',
      plug: 'Transform',
      property: 'translation',
    },
    { x: feetDistance * IN_TO_M, y: 0, z: 0 }
  );
}

export function updateColor(claraApi, type, color, optionalParent) {
  const templateName = `${type}_${color}`;
  const referenceId = claraApi.scene.find({
    name: templateName,
    type: 'Material',
  });
  if (!referenceId)
    return message.error(`Missing material ${templateName} in the main scene!`);
  const query = {
    from: { id: optionalParent },
    name: `Paintable_${type}`,
  };
  if (!claraApi.scene.filter({ ...query, type: 'Material' }).length) return;
  Object.assign(query, { plug: 'Material' });
  updateMaterialBasedOnReference(claraApi, referenceId, query);
}

function updateMaterialBasedOnReference(claraApi, referenceId, query) {
  const referenceProperty = claraApi._store.get('sceneGraph').nodes[referenceId]
    .plugs.Material[0];
  Object.entries(referenceProperty).forEach(([property, value]) =>
    claraApi.scene.setAll({ ...query, property }, value)
  );
}

export default function initScene(claraApi, appApi, appState) {
  const { configuration } = appState;
  if (configuration.uprightPosition.value)
    updateUprightPosition(claraApi, appState);
  if (configuration.width.value) updateFeetPosition(claraApi, appState);
  const color = {
    colorStandardPaint: configuration.colorStandardPaint.value,
    colorStandardLaminate: configuration.colorStandardLaminate.value,
  };
  Object.entries(color).forEach(([attrName, value]) => {
    if (!value) {
      const colorAttribute = appApi.config.getAttribute(attrName);
      const defaultColor = colorAttribute.defaultValue;
      configuration[attrName] = { value: defaultColor };
      color[attrName] = defaultColor;
    }
  });
  updateColor(claraApi, 'Metal', color.colorStandardPaint);
  updateColor(claraApi, 'Laminate', color.colorStandardLaminate);

  return configuration;
}



// WEBPACK FOOTER //
// ./src/helper/scene.js